import React from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownRenderer = ({ content }) => {
  return (
    <ReactMarkdown
      components={{
        // Unordered lists
        ul: ({ node, ...props }) => (
          <ul className="list-disc pl-6 space-y-1 text-white" {...props} />
        ),
        // Ordered lists
        ol: ({ node, ...props }) => (
          <ol className="list-decimal pl-6 space-y-1 text-white" {...props} />
        ),
        // List items
        li: ({ node, ...props }) => (
          <li className="mt-1 text-white" {...props} />
        ),
        // Paragraphs
        p: ({ node, ...props }) => (
          <p className="my-2 text-white" {...props} />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
